const namespaced = true

const state = {
  noLogin: false
}

const mutations = {
  SET_NO_LOGIN(state, payload) {
    state.noLogin = payload
  }
}

const actions = {
  setNoLoginOn({ commit }) {
    commit('SET_NO_LOGIN', true)
  },
  setNoLoginOff({ commit }) {
    commit('SET_NO_LOGIN', false)
  }
}

const getters = {
  getNoLogin: state => state.noLogin
}

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}
